"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthHistoryCaseResponseToJSON = exports.HealthHistoryCaseResponseFromJSONTyped = exports.HealthHistoryCaseResponseFromJSON = exports.instanceOfHealthHistoryCaseResponse = exports.HealthHistoryCaseResponseSideEnum = exports.HealthHistoryCaseResponseRelationshipEnum = void 0;
var runtime_1 = require("../runtime");
var ConditionResponse_1 = require("./ConditionResponse");
/**
 * @export
 */
exports.HealthHistoryCaseResponseRelationshipEnum = {
    Self: 'Self',
    Mother: 'Mother',
    Father: 'Father',
    Brother: 'Brother',
    Sister: 'Sister',
    Grandson: 'Grandson',
    Granddaughter: 'Granddaughter',
    PartnerMale: 'Partner (Male)',
    PartnerFemale: 'Partner (Female)',
    Son: 'Son',
    Daughter: 'Daughter',
    CousinMale: 'Cousin (Male)',
    CousinFemale: 'Cousin (Female)',
    Nephew: 'Nephew',
    Niece: 'Niece',
    Uncle: 'Uncle',
    Aunt: 'Aunt',
    HalfBrother: 'Half-brother',
    HalfSister: 'Half-sister',
    Grandfather: 'Grandfather',
    Grandmother: 'Grandmother'
};
/**
 * @export
 */
exports.HealthHistoryCaseResponseSideEnum = {
    Maternal: 'Maternal',
    Paternal: 'Paternal'
};
/**
 * Check if a given object implements the HealthHistoryCaseResponse interface.
 */
function instanceOfHealthHistoryCaseResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfHealthHistoryCaseResponse = instanceOfHealthHistoryCaseResponse;
function HealthHistoryCaseResponseFromJSON(json) {
    return HealthHistoryCaseResponseFromJSONTyped(json, false);
}
exports.HealthHistoryCaseResponseFromJSON = HealthHistoryCaseResponseFromJSON;
function HealthHistoryCaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'relationship': !(0, runtime_1.exists)(json, 'relationship') ? undefined : json['relationship'],
        'side': !(0, runtime_1.exists)(json, 'side') ? undefined : json['side'],
        'conditions': !(0, runtime_1.exists)(json, 'conditions') ? undefined : (json['conditions'].map(ConditionResponse_1.ConditionResponseFromJSON)),
    };
}
exports.HealthHistoryCaseResponseFromJSONTyped = HealthHistoryCaseResponseFromJSONTyped;
function HealthHistoryCaseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'relationship': value.relationship,
        'side': value.side,
        'conditions': value.conditions === undefined ? undefined : (value.conditions.map(ConditionResponse_1.ConditionResponseToJSON)),
    };
}
exports.HealthHistoryCaseResponseToJSON = HealthHistoryCaseResponseToJSON;
